<template>
  <nav id="navbar" :class="{ 'nav-hidden': !navShown }">
    <ul>
      <router-link to="/">domov</router-link>
      <router-link to="/galeria">galéria</router-link>
      <router-link to="/kontakt">kontakt</router-link>
      <router-link v-if="showKurzKresby" to="/kurz-kresby-2026">kurz kresby 2026</router-link>
    </ul>
  </nav>
</template>

<script>
import { SHOW_KURZ_KRESBY } from "@/config/features"

export default {
  name: "Navbar",
  data: () => {
    return {
      showKurzKresby: SHOW_KURZ_KRESBY,
      navShown: true,
      lastScroll: 0,
      scrollAccumulator: 0,
      topThreshold: 80,
      hideBuffer: 80,
      showBuffer: 3
    }
  },
  mounted () {
    this.lastScroll = window.scrollY
    window.addEventListener("scroll", this.onScroll)
  },
  unmounted () {
    window.removeEventListener("scroll", this.onScroll)
  },
  watch: {
    $route () {
      this.lastScroll = 0
      this.scrollAccumulator = 0
      this.showNav()
    }
  },
  methods: {
    showNav () {
      this.navShown = true
    },
    hideNav () {
      this.navShown = false
    },
    onScroll () {
      const currentScroll = window.scrollY
      const delta = currentScroll - this.lastScroll
      this.lastScroll = currentScroll

      if (currentScroll < this.topThreshold) {
        this.scrollAccumulator = 0
        this.showNav()
        return
      }

      // Reset accumulator on direction change so buffers measure sustained travel.
      if ((delta > 0 && this.scrollAccumulator < 0) || (delta < 0 && this.scrollAccumulator > 0)) {
        this.scrollAccumulator = 0
      }
      this.scrollAccumulator += delta

      if (this.scrollAccumulator >= this.hideBuffer) {
        this.hideNav()
        this.scrollAccumulator = 0
      } else if (this.scrollAccumulator <= -this.showBuffer) {
        this.showNav()
        this.scrollAccumulator = 0
      }
    }
  }
}

</script>

<style scoped>

#navbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1000;
  min-width: 320px;
  min-height: var(--nav-height);

  display: flex;
  flex-flow: row wrap;
  align-items: center;
  align-content: center;
  justify-content: center;

  background-color: var(--background-primary);

  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}

#navbar.nav-hidden {
  transform: translateY(-100%);
  opacity: 0;
}

#navbar ul {
  margin: 0 var(--side-margin);
  white-space: nowrap;
}

#navbar a {
  color: var(--text-primary);
  font-size: 1.1em;
  padding: 0 3px;
  margin: 0 5px;
  text-decoration: none;

  position: relative;
  transition: 300ms ease;
}

#navbar a::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background-color: var(--highlight);
  transition: 400ms ease;
  transform-origin: left center;
  transform: scaleX(0);
}

#navbar a:hover::after {
  transform: scaleX(1);
}

#navbar a.router-link-exact-active {
  color: darkslategrey;
}

#navbar a.router-link-exact-active::after {
  transform: scaleX(1);
}

/*IPhone SE (2.gen) a väčšie*/
@media only screen and (min-width: 375px) {
  #navbar a {
    font-size: 1.2em;
    padding: 0 5px;
    margin: 0 8px;
  }
}

/*Plná stránka - tablety, notebooky...*/
@media only screen and (min-width: 1200px) {
  #navbar {
    justify-content: left;
    flex-flow: row nowrap;
  }

  #navbar a {
    font-size: 2em;
    padding: 0 10px 0 0;
    margin: 0 50px 0 0;
  }

  #navbar p {
    margin-right: var(--side-margin);
    font-size: 1rem;
  }
}

</style>
